<template>
    <div class="container confirmation-container">
        <div class="row">
            <div class="col-12 col-lg-6">
                <h1 class="h2">{{microcopy?.heading}}</h1>
                <p>{{microcopy?.summary}}</p>
            </div>
            <div class="col-12 col-lg-6 mt-5 mt-lg-0">
                <div class="rounded--col" v-html="microcopy?.openingHours">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            microcopy: ''
        }
    },
    mounted() {
        const el = document.querySelector('.step--confirmation');
        if (el?.classList?.contains('d-none')) {
            el.classList.remove('d-none');
        }
        this.microcopy = window.mortgageRequestMicrocopy.submissionPage;
        document.title = this.microcopy?.metaTitle
    }
}
</script>